"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDuration = void 0;
const timeMultipliers = {
    day: 24 * 60 * 60 * 1000,
    days: 24 * 60 * 60 * 1000,
    hour: 60 * 60 * 1000,
    hours: 60 * 60 * 1000,
    millisecond: 1,
    milliseconds: 1,
    minute: 60 * 1000,
    minutes: 60 * 1000,
    second: 1000,
    seconds: 1000,
};
const getDuration = (ttl, format) => {
    const regex = 
    // eslint-disable-next-line unicorn/no-unsafe-regex
    /(\d+(?:\.\d+)?) (milliseconds?|seconds?|minutes?|hours?|days?)/gu;
    let totalMilliseconds = 0;
    let match;
    while ((match = regex.exec(ttl)) !== null) {
        const value = Number.parseFloat(match[1]);
        const interval = match[2];
        totalMilliseconds += value * timeMultipliers[interval];
    }
    const result = totalMilliseconds / timeMultipliers[format];
    return result;
};
exports.getDuration = getDuration;
//# sourceMappingURL=getDuration.js.map